import { VarianteChip } from '../ui';

/**
 * O estado de um contrato, em texto e cor (at-69, frente D/D7).
 *
 * É a tabela `ROTULO_STATUS` que vivia dentro de `views/ti/pages/contratos.tsx`,
 * com as classes CSS próprias trocadas pelas variantes do `Chip`. Sai da view
 * porque a mesma regra vai ser lida por outra tela: o **item 61** do backlog é a
 * visão do consultor sobre os contratos dos associados dele, e as duas não podem
 * discordar sobre o que "EMITIDO" significa (convenção at-24/at-56).
 *
 * ⚠️ **`EMITIDO` é `pendente`, não `perigo`.** Contrato emitido e não assinado é
 * o estado normal de quem acabou de fechar a adesão — o prazo é de 7 dias
 * (`RegrasDeContrato`). Vermelho fica para `CANCELADO`, que é decisão tomada.
 *
 * ⚠️ **Status desconhecido devolve o PRÓPRIO valor em `neutro`**, nunca um chip
 * mudo nem uma exceção: se o backend acrescentar um estado à `StatusContrato`, o
 * TI vê o nome dele em vez de um espaço em branco. Mesmo princípio com que o SAAC
 * trata a `situacao` do SGA — relata o fato, não interpreta (at-32).
 */

export interface RotuloStatusContrato {
  texto: string;
  variante: VarianteChip;
}

const TABELA: Record<string, RotuloStatusContrato> = {
  RASCUNHO: { texto: 'Rascunho', variante: 'neutro' },
  EMITIDO: { texto: 'Aguardando assinatura', variante: 'pendente' },
  ASSINADO: { texto: 'Assinado', variante: 'ok' },
  CANCELADO: { texto: 'Cancelado', variante: 'perigo' },
  SUBSTITUIDO: { texto: 'Substituído', variante: 'neutro' },
};

export function rotuloStatusContrato(status: string): RotuloStatusContrato {
  return TABELA[status] ?? { texto: status, variante: 'neutro' };
}
